var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircledGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.4231 8.26641C16.5702 8.03273 16.5001 7.72402 16.2664 7.57688C16.0327 7.42975 15.724 7.49991 15.5769 7.73359L10.9024 15.1578L8.38062 12.1975C8.20155 11.9873 7.88598 11.962 7.67577 12.1411C7.46556 12.3202 7.44031 12.6358 7.61938 12.846L10.5823 16.3242C10.6855 16.4453 10.8402 16.5101 10.9988 16.4987C11.1575 16.4873 11.3013 16.401 11.3861 16.2664L16.4231 8.26641Z",
    fill: "#4B9560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircledGreen);
export default __webpack_public_path__ + "static/media/CheckmarkCircledGreen.024b62296dc8d1054bd1f25828f575c1.svg";
export { ForwardRef as ReactComponent };